import { render } from "./Selection.vue?vue&type=template&id=6628767e&ts=true"
import script from "./Selection.vue?vue&type=script&lang=ts"
export * from "./Selection.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/prod_electronic-delivery-responsive_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__